// Colour swatches on product cards (see snippets/wz-card-swatches.liquid).
// Delegated from the document so it covers every grid on the page and keeps
// working for cards added later by pagination or section re-rendering.
document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.cfc-swatch');
  if (!swatch) return;

  var card = swatch.closest('.cfc-card');
  if (!card) return;

  var image = card.querySelector('.cfc-card__image-wrapper img');
  var link = card.querySelector('.cfc-card__link');
  var orderButton = card.querySelector('.cfc-card__order');
  var nextImage = swatch.getAttribute('data-variant-image');
  var nextUrl = swatch.getAttribute('data-variant-url');

  // A variant with no photo of its own keeps the current image rather than
  // blanking the card.
  if (image && nextImage) {
    image.src = nextImage;
  }

  if (link && nextUrl) {
    link.setAttribute('href', nextUrl);
  }

  // Keep Order now pointed at the same variant as the card, so a colour picked
  // here is still selected on the product page. Anchors only — the sold-out
  // state renders as a <span> and has nowhere to go.
  if (orderButton && nextUrl && orderButton.tagName === 'A') {
    orderButton.setAttribute('href', nextUrl);
  }

  card.querySelectorAll('.cfc-swatch').forEach(function (element) {
    element.classList.toggle('is-selected', element === swatch);
  });

  // The card now shows the chosen colour; stop the hover photo covering it.
  card.classList.add('is-swatched');
});
